/**
 * @since 2026-04-21
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { PERIOD_OPTIONS } from "./chartUtils";
import "./ChartCard.scss";

const ChartCard = ({
  title,
  period,
  onPeriodChange,
  periods = PERIOD_OPTIONS,
  rightSlot,
  children,
}) => {
  const handlePeriodChange = (_event, next) => {
    if (next !== null) onPeriodChange?.(next);
  };

  const showHeader = title || period || rightSlot;

  return (
    <div className="chartCard">
      {showHeader && (
        <div className="chartCard__header">
          {title && <h4 className="chartCard__title">{title}</h4>}
          <div className="chartCard__controls">
            {period && (
              <ToggleButtonGroup
                value={period}
                exclusive
                onChange={handlePeriodChange}
                aria-label="chart period"
                className="chartCard__toggle"
                size="small"
              >
                {periods.map((p) => (
                  <ToggleButton key={p.id} value={p.id} aria-label={p.label}>
                    {p.label}
                  </ToggleButton>
                ))}
              </ToggleButtonGroup>
            )}
            {rightSlot}
          </div>
        </div>
      )}
      <div className="chartCard__body">{children}</div>
    </div>
  );
};

export default ChartCard;
